module.exports = __webpack_public_path__ + "img/pro_two_4.9864db17.jpg";